<template>
  <div>
    <b-row>
      <b-col md="9" class="my-1">
        <b-form-group horizontal label="Поиск" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Введите текст" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Очистить</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <!--<b-col>
        <download-excel
        class   = "btn btn-secondary"
        :fields="xlsFields"
        :data="items"
        :worksheet = "workSheet"
        :name = "fileName">
        Экспорт в Excel
      </download-excel>
      </b-col>-->
    </b-row>
    <br>
<b-table striped
         small
         hover
         :filter="filter"
         :items="items"
         :fields="fields_data"
         :current-page="currentPage"
         :per-page="perPage"
         @filtered="onFiltered">
  <template slot="count_case" slot-scope="row">
    <b-button size="sm" @click.stop="info(row.item, row.index, $event.target)" class="mr-1">
         +{{ row.item.count_case }}
        </b-button>
  </template>
</b-table>
<b-row>
  <b-col md="6" class="my-1">
  <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
  </b-col>
</b-row>
    <!-- Info modal -->
    <b-modal size="lg" id="modalInfo" @hide="resetModal" :title="modalInfo.title" ok-only>
      <b-card>
      <b-row>
        <b-col md="4">Дата рождения:</b-col><b-col>{{ modalInfo.info[2] }}</b-col>
      </b-row>
      <b-row>
        <b-col md="4">Телефон:</b-col><b-col>{{ modalInfo.info[1] }}</b-col>
      </b-row>
        <b-row>
        <b-col md="4" border="bottom">Адрес:</b-col><b-col>{{ modalInfo.addr }}</b-col>
      </b-row>
        <b-row>
        <b-col md="4">Доп. информация:</b-col><b-col>{{ modalInfo.info[3] }}</b-col>
      </b-row>
        </b-card>
      <div>
        <b-table striped
         small
         hover
         :items="modalInfo.items"
         :fields="modalInfo.fields_data"></b-table>
          <!--<b-pagination :total-rows="modalInfo.totalRows" :per-page="modalInfo.perPage" v-model="modalInfo.currentPage" class="my-0" />-->
      </div>
    </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import CasesTable from './CasesTable'
let reqPath = process.env.VUE_APP_RECORD_REQ_URL
export default {
  name: 'ClientTable',
  components: {CasesTable},
  props: ['items'],
  data () {
    return {
      xlsFields: {
        'ФИО': 'fio',
        'Район': 'reg_name',
        'Консультации о работе ЛПУ, аптек, по здоровью': 'c1',
        'Вызов скорой медицинской помощи': 'c2',
        'Вопросы связанные с коммунальными службами': 'c3',
        'Вопросы социального характера': 'c4',
        'Плановая консультация по востребованным услугам (Проверочный звонок)': 'c5',
        'Технический вопрос (устройство ТК)': 'c6',
        'Случайное нажатие на кноаку вызова ТК': 'c7',
        'Вызов Экстренных служб полиции и МЧС': 'c8',
        'Вызов участкового врача': 'c9',
        'Запись к врачу': 'c10',
        'Итого обработанных звонков': 'c11'
      },
      reqPath: 'https://stat.zabota365.ru',
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      pageOptions: [ 5, 10, 15 ],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: {
        title: '',
        content: '',
        info: [],
        addr: '',
        items: [],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [ 5, 10, 15 ],
        fields_data: [
          {
            label: 'Дата',
            key: 'date_open',
            sortable: true
          },
          {
            label: 'Заявка',
            key: 'ctype',
            sortable: true
          },
          {
            label: 'Описание',
            key: 'chint',
            sortable: true
          }
          /* {
            label: 'Комментарий',
            key: 'cmt',
            sortable: true
          } */
        ]
      },
      streetName: ['ул.', 'пр.', 'пр-д', 'пер.', 'пл.', 'наб.', 'бульвар', 'тупик', 'кольцо', 'сквер', 'линия', 'другое'],
      fields_data: [
        {
          label: 'Район',
          key: 'reg_name',
          sortable: true
        },
        {
          label: 'ФИО',
          key: 'full_name',
          sortable: true
        },
        {
          label: 'Заявки',
          key: 'count_case',
          sortable: true
        }
      ]
    }
  },
  mounted () {
    this.totalRows = this.items.length
  },
  computed: {
    workSheet () {
      return 'Детализация ' + localStorage.getItem('dateFrom') + ' - ' + localStorage.getItem('dateTo')
    },
    fileName () {
      return 'Детализация ' + localStorage.getItem('dateFrom') + ' - ' + localStorage.getItem('dateTo') + '.xls'
    }
  },
  watch: {
    items (newVal, oldVal) {
      this.totalRows = newVal.length
    }
  },
  methods: {
    info (item, index, button) {
      console.log(item)
      this.modalInfo.title = item.full_name // `Row index: ${index}`
      this.modalInfo.content = JSON.stringify(item, null, 2)
      this.getClientDataExt(item.client_id)
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getClientDataExt (clientId) {
      let path = reqPath + '/api/lenobl/v.1/getClientListExt'
      let dateFrom = localStorage.getItem('dateFrom')
      let dateTo = localStorage.getItem('dateTo')
      axios.post(path, {
        datefrom: dateFrom,
        dateto: dateTo,
        client_id: clientId
      })
        .then(response => {
          console.log(window.location.hostname + window.location.port)
          this.modalInfo.info = response.data.info
          // this.modalInfo.title += this.modalInfo.info[1]
          let _str = response.data.addr[0]
          this.modalInfo.info[2] = (new Date(this.modalInfo.info[2])).toLocaleDateString()
          let _str1 = this.modalInfo.info[1]
          this.modalInfo.info[1] = '+' + _str1[0] + ' (' + _str1.substring(1, 4) + ') ' + _str1.substring(4, 7) + '-' + _str1.substring(7, 11)
          this.modalInfo.addr = _str[0] + ', ' + this.streetName[_str[2]] + ' ' + _str[1] + ', дом ' + _str[3] + ', кв ' + _str[4]
          this.modalInfo.items = [].map.call(response.data.cases, (obj) => { return {'date_open': obj[0], 'ctype': obj[2], 'chint': obj[3], 'cmt': obj[4].replace(/<br>/gmi, ' ')} })
          // this.clientsList = [].map.call(response.data, (obj) => { return { 'reg_name': obj[3], 'full_name': obj[4], 'count_case': obj[5], 'reg_id': obj[0], 'client_id': obj[2] } })
          // localStorage.setItem('clientsList', JSON.stringify(this.clientsList))
          // this.data_grp = [].map.call(response.data, (obj) => { return obj[1] })
          // this.randomNumber = response.data.randomNumber
        })
        .catch(error => {
          console.log(error)
        })
      //
    }
  }
}
</script>

<style scoped>
.spacer {
    margin-top: 40px; /* define margin as you see fit */
}
</style>



// WEBPACK FOOTER //
// src/components/ClientTable.vue